"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactResponsive = require("react-responsive");

var _hooks = require("../../hooks");

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MinTablet = function MinTablet(_ref) {
  var children = _ref.children;
  var theme = (0, _hooks.useTheme)();
  var isTablet = (0, _reactResponsive.useMediaQuery)({
    query: (0, _helpers.breakpoint)('minTablet')({
      theme: theme
    })
  });
  return isTablet ? _react.default.createElement(_react.default.Fragment, null, children) : null;
};

var _default = MinTablet;
exports.default = _default;